  <template>
  <!-- 油品发票明细 -->
  <el-dialog title="账单明细" :visible.sync="dialogVisible" :close-on-click-modal="closeModal" :close-on-press-escape="closeEscape" :before-close="close" class="bill-detail-dialog" width="900px">
    <div class="oil-invoice-detail-wrapper">
      <div class="oil-detail-handler">
        <!-- <el-button size="mini" @click="download" icon="el-icon-download">下载</el-button> -->
        <download-button :downloadApi="downloadDetailApi" :queryParams="{ ...data }" @onChangePage="closeLog"></download-button>
        <div class="tips">提示：历史账单暂无明细及可能存在油品字段为空，如需明细，请联系能链商务人员</div>
      </div>
      <mer-table :loading="tableLoading"
        :tableConfig="tableConfig"
        :tableData="tableData"
        :pagination="pagination"
        @SizeChange="handleSizeChange"
        @PageChange="pageChange"
        :hasIndex="true">
        <template slot="handler" slot-scope="{row}">
          <el-button-group v-show="data.billMonth >= '2022-01'" >
            <download-button :downloadApi="downloadOrderList" :queryParams="{ gasId: row.gasId, payDt: row.billDate }" @onChangePage="closeLog" text="订单下载"></download-button>
          </el-button-group>
        </template>
      </mer-table>
    </div>
  </el-dialog>
</template>
<script>
import dialog from '@mix/dialog'
import listPage from '@/mixins/listPage'
import queryMix from '@/views/finance/mixins/query';
import { queryInvoiceOrderDetails, getGasDailyInvoiceList, downloadOrderList, downLoaderInvoiceDetails } from '@/api/finance'
// 表格参数配置
// 非单油站、非商户
// let tableConfig = [
//   { label: '油站编码', prop: 'gasId', width: 150 },
//   { label: '油站名称', prop: 'gasName', width: 136  },
//   { label: '油号', prop: 'oilNoName', width: 180  },
//   { label: '商户应开发票总金额', prop: 'invoiceAmount',width: 136 },
//   { label: '账单日期', prop: 'billDate', width: 136  },
//   { label: '操作', slot: 'handler', fixed: 'right', width: 150 }
// ]
// 单油站、商户，2022/6月前
let tableConfigAgo = [
  { label: '账单日期', prop: 'billDate', width: 136  },
  { label: '油站编码', prop: 'gasId', width: 150 },
  { label: '油站名称', prop: 'gasName', width: 136  },
  { label: '账单金额（元）', prop: 'invoiceAmount',width: 136 },
]
// 单油站、商户，2022/6月后
let tableConfigAfter = [
  { label: '订单号', prop: 'orderNo', width: 136  },
  { label: '交易日期', prop: 'billDate', width: 136  },
  { label: '油站编码', prop: 'gasId', width: 150 },
  { label: '油站名称', prop: 'gasName', width: 136  },
  { label: '品类', prop: 'oilSpuName', width: 136  },
  { label: '订单来源', prop: 'businessTypeDesc', width: 136  },
  { label: '订单类型', prop: 'orderTypeDesc', width: 136  },
  { label: '账单金额（元）', prop: 'invoiceAmount',width: 136 },
]

export default {
  mixins: [dialog, listPage, queryMix],
  props:{
    data:{
      type: Object,
      default: () => ( {} )
    },
    singleGas: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      downloadDetailApi: downLoaderInvoiceDetails,
      downloadOrderList,
      tableConfig: [],
    }
  },
  created(){
    this.initPage()
  },
  methods:{
    initPage () {
      let useApi
      // if (!this.singleGas) {
      //   useApi = getOilInvoiceDetailApi
      //   this.tableConfig = tableConfig
      // } else if (this.data.billMonth <= '2022-06') {
      //   useApi = getGasDailyInvoiceList
      //   this.tableConfig = tableConfigAgo
      // } else {
      //   useApi = queryInvoiceOrderDetails
      //   this.tableConfig = tableConfigAfter
      // }
      if (this.data.billMonth <= '2022-06') {
        useApi = getGasDailyInvoiceList
        this.tableConfig = tableConfigAgo
      } else {
        useApi = queryInvoiceOrderDetails
        this.tableConfig = tableConfigAfter
      }
      //此处，需要给接口传的参数，需要防在searchBar里
      this.initList(useApi,false, null, this.data)
    },
    closeLog () {
      this.dialogVisible = false
      this.$emit('close')
    }
    // download () {
    //   this.downloadFile(downloadOilInvoiceDetailApi,'账单明细列表',this.data)
    // }
  }
}
</script>
<style lang="less" scoped>
.oil-invoice-detail-wrapper{
  padding-bottom: 25px;
  .oil-detail-handler{
    padding: 0 5px;
    display: flex;
    align-items: center;
    .tips {
        margin-left: 20px;
    }
  }
}
</style>